import constants from './constants';

const initState = {
  createNewPortals: {
    id: '',
    version: '',
    fw_url: {},
    fw_crc: '',
  },
  portalsIdToEdit: null,
};

function portalsReducer(state = initState, { type, payload }) {

  switch (type) {

    case constants.SET_CREATE_EDIT_PORTALS:
      return {
        ...state,
        createNewPortals: payload,
      };

    case constants.SET_PORTALS_ID_TO_EDIT:
      return {
        ...state,
        portalsIdToEdit: payload,
      };

    default:
      return state;

  }

}

export default portalsReducer;
